import {
  Box,
  Container,
  Flex,
  Heading,
  HStack,
  IconButton,
} from '@chakra-ui/react';
import { TODO } from '@habity/types';

type HeaderProps = {
  title: string;
  onClickBack: () => void;
  icon: TODO;
};

export const ProfileHeaderMobile = ({
  title,
  onClickBack,
  icon,
}: HeaderProps) => {
  return (
    <Box
      as="nav"
      backgroundColor="white"
      role="navigation"
      position="fixed"
      top="0"
      left="0"
      right="0"
      w="full"
      zIndex="docked"
      h={{ mobile: '60px', desktop: '72px' }}
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Container
        maxW={{ mobile: '100vw', desktop: '5xl' }}
        px={{ mobile: 4, desktop: 20 }}
      >
        <Flex
          as="section"
          h="100%"
          justifyContent="space-between"
          align="center"
        >
          <HStack spacing="2">
            <Heading size="md">{title}</Heading>
          </HStack>
          <IconButton
            aria-label="Stäng"
            size="lg"
            icon={icon}
            variant="outline"
            onClick={onClickBack}
          />
        </Flex>
      </Container>
    </Box>
  );
};
